import { createContext, useContext } from 'react';

import {
  CustomersWithCustomElementsE,
  DashboardTypeE,
  TransportTypeCustomersE,
} from '../declarations/enums/common';
import { ThemeE } from '../declarations/enums/theme';
import { CustomerConfigI } from '../declarations/interfaces/customer';

type ContextT = {
  isMuralToTheme: boolean;
  isTransportDashboardType: boolean;
  isWayajCustomer: boolean;
  isIlhaDeToque: boolean;
} & CustomerConfigI;

type CommonProviderPropsT = {
  children: React.ReactElement | React.ReactElement[];
  value: CustomerConfigI;
};

const CommonCtx = createContext<ContextT>({} as ContextT);

const CommonProvider: React.FC<CommonProviderPropsT> = ({ children, value }) => {
  const { calculatorThemeDto, dashBoardType, customerId, slugUrl } = value;

  const isMuralToTheme = ThemeE.MURALTO === calculatorThemeDto?.name;
  const isTransportDashboardType = dashBoardType === DashboardTypeE.TRANSPORT;
  const isWayajCustomer = TransportTypeCustomersE.WAYAJ_EARTH_FRIENDLY_TRAVEL === customerId;
  const isIlhaDeToque =
    CustomersWithCustomElementsE.ILHA_DE_TOQUE_ECO_BOTIQUE_HOTEL_SAO_SEBASTIAO === slugUrl;

  const data = {
    ...value,
    isMuralToTheme,
    isTransportDashboardType,
    isWayajCustomer,
    isIlhaDeToque,
  };

  return <CommonCtx.Provider value={data}>{children}</CommonCtx.Provider>;
};

export default CommonProvider;

export const useCommon = () => useContext(CommonCtx);
